export default "__VITE_ASSET__B9q6yGxZ__"